// date strings for the function dateFormat will live
export const weekDay = 'EEE';
export const longWeekDay = 'EEEE';
export const monthDayYear = 'MMMM d, yyyy';
export const weekDayMonthDay = 'EEE, MMMM d';
export const longWeekDayMonthDay = 'EEEE, MMMM d';
export const monthDay = 'MMMM d';
